import React, { useState, useEffect } from 'react'
import { Container, Row, Col } from 'react-grid-system'
// import { filter } from 'lodash'
import { useStore } from 'react-redux'
import classNames from 'classnames'
import { ToastContainer } from 'react-toastify'

import Header from '../Header'
import Table from '../Table'
import ModalWindow from '../common/Modal'
import styles from './Main.module.scss'
import { SAVING, DEFAULT } from '../../utils/constants'
import previewInvoice from '../../assets/invoices/szamla.png'
import InfoBar from '../common/InfoBox'

/**
* @author zilahir <zilahi@gmail.com>
* @function Main
* */

const Main = () => {
	const store = useStore()
	const [jsonVal, setJsonVal] = useState(null)
	const [isSavingModalVisible, setSavingModalVisible] = useState(false)
	useEffect(() => store.subscribe(() => {
		const jsonValue = store.getState().jsonVal.jsonVal
		setJsonVal(jsonValue)
	}), [store, jsonVal])

	function handleModify() {
		setSavingModalVisible(true)
	}

	return (
		<div>
			<ToastContainer />
			<div className={styles.headerContainer}>
				<Header />
			</div>
			<Container
				fluid
				className={styles.rootContainer}
			>
				<Row>
					<Col>
						<div className={!jsonVal ? styles.hidden : styles.buttonContainer}>
							<button
								type="button"
								onClick={() => handleModify()}
								className={styles.modifyButton}
							>
								Save
							</button>
						</div>
					</Col>
				</Row>
				<Row
					justify="center"
				>
					<Col
						lg={6}
					>
						<div className={classNames(
							!jsonVal ? styles.hidden : null,
						)}
						>
							<Table invoiceData={jsonVal} />
						</div>
					</Col>
					<Col lg={6}>
						<div
							className={!jsonVal ? styles.hidden : styles.originalContainer}
						>
							<img src={previewInvoice} alt="invoice" />
						</div>
					</Col>
					{
						!jsonVal
							? (
								<Col lg={8}>
									<InfoBar type={DEFAULT} message="To get started, open the right sidebar, and select an invoice from the list!" />
								</Col>
							)
							: null
					}
				</Row>
			</Container>
			<ModalWindow
				purpuse={SAVING}
				isVisible={isSavingModalVisible}
				requestClose={() => setSavingModalVisible(false)}
			/>
		</div>
	)
}

export default Main
